export default __webpack_public_path__ + "static/media/16.942386ea.svg";